// extracted by mini-css-extract-plugin
module.exports = {"chevron":"LinkWithChevron_chevron__8GFuw","linkWithChevron":"LinkWithChevron_linkWithChevron__is6B7"};